import React, { useState } from 'react'
import { OnClickMenu, OnClickMenuItem } from 'uiComponents/menus'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { TaxConfiguration } from './types'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import './css/actionMenu.scss'
import { useTranslation } from 'translations'

interface ActionMenuProps {
    taxConfiguration: TaxConfiguration
    editingTaxConfiguration: boolean
    isDefault?: boolean
    setDefaultTaxConfiguration: (taxConfigurationUuid: string) => void
    deleteTaxConfiguration: (taxConfigurationUuid: string) => void
    cancel: () => void
}

export const ActionMenu = ({
    taxConfiguration,
    editingTaxConfiguration,
    isDefault,
    setDefaultTaxConfiguration,
    deleteTaxConfiguration,
    cancel,
}: ActionMenuProps) => {
    const { t } = useTranslation()
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false)
    const canSetDefault = !isDefault && !editingTaxConfiguration
    const setDefaultTitle = isDefault
        ? t('settings.accountSettings.taxConfigurations.actionMenu.alreadyDefault')
        : editingTaxConfiguration
        ? t('settings.accountSettings.taxConfigurations.actionMenu.saveFirst')
        : t('settings.accountSettings.taxConfigurations.actionMenu.makeDefault')

    const canDelete = !isDefault
    const deleteTitle = isDefault
        ? t('settings.accountSettings.taxConfigurations.actionMenu.cannotDeleteDefault')
        : t('settings.accountSettings.taxConfigurations.actionMenu.deleteThis')

    return (
        <>
            <OnClickMenu
                className="actions"
                title={t('settings.accountSettings.taxConfigurations.actionMenu.title')}
                kind="action"
                iconTrigger={faEllipsisV as IconProp}
                secondary
            >
                <OnClickMenuItem
                    className={`setDefault${!canSetDefault ? ' disabled' : ''}`}
                    title={setDefaultTitle}
                    onClick={() => {
                        if (canSetDefault) {
                            setDefaultTaxConfiguration(taxConfiguration.uuid)
                        }
                    }}
                >
                    {t('settings.accountSettings.taxConfigurations.actionMenu.setAsDefault')}
                </OnClickMenuItem>
                <OnClickMenuItem
                    className={`delete${!canDelete ? ' disabled' : ''}`}
                    title={deleteTitle}
                    onClick={() => {
                        if (canDelete) {
                            setShowDeleteConfirmationDialog(true)
                        }
                    }}
                >
                    {t('common.delete')}
                </OnClickMenuItem>
            </OnClickMenu>
            {showDeleteConfirmationDialog && (
                <ConfirmationDialog
                    title={t('settings.accountSettings.taxConfigurations.actionMenu.deleteConfirmTitle')}
                    text={t('settings.accountSettings.taxConfigurations.actionMenu.deleteConfirmText')}
                    buttonText={t('common.delete')}
                    className="deleteTaxConfigurationConfirmationDialog"
                    onCancel={() => setShowDeleteConfirmationDialog(false)}
                    onConfirm={() => {
                        if (taxConfiguration.uuid) {
                            deleteTaxConfiguration(taxConfiguration.uuid)
                        } else {
                            cancel()
                        }
                        setShowDeleteConfirmationDialog(false)
                    }}
                />
            )}
        </>
    )
}
